export const decodeBase64 = (str) => {
    if (/[a-zA-Z]/.test(str)) {
        return parseInt(decodeURIComponent(escape(window.atob(str))).split(":")[1]);
    } else {
        return parseInt(str);
    }
};